// @flow
/** @jsx h */
import { h } from 'preact';
import { styled } from 'goober';
import Modal from './Modal';
import CustomButton from './CustomButton';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useErrorModalContextDispatch } from '../../storeProviders/errorModalStore';
import type { ErrorModalType } from '../../storeProviders/errorModalStore';
import Match from 'preact-router/match';
import { route } from 'preact-router';
import { useCheckoutTracker } from './tracker';

const ErrorModalContainer = styled('div')`
  .buttonsContainer {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: center;
  }
  .buttonContainer {
    width: 100%;
  }
  .title {
    font-weight: 600;
    font-size: 24px;
    line-height: 1;
    text-align: center;
    color: var(--primaryCTAColor);
  }
  .message {
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #636363;
    text-align: center;
    margin: 18px 0px 32px;
  }
  .retryButton {
    color: #ffffff !important;
    width: 100% !important;
    max-width: ${(props) =>
      props.bothButtonsEnaled ? '150px !important' : '100% !important'};
    height: 50px !important;
    border-radius: 8px !important;
    font-size: 18px !important;
  }
  .exitButton {
    color: #000000 !important;
    width: 100% !important;
    max-width: ${(props) =>
      props.bothButtonsEnaled ? '150px !important' : '100% !important'};
    height: 50px !important;
    border-radius: 8px !important;
    font-size: 18px !important;
    background-color: #d9d9d9 !important;
  }

  .errorModalBox {
    max-width: 395px;
    width: 95%;
    background-color: #ffffff;
    padding: 45px 30px;
    line-height: 0;
    border-radius: 15px 15px 0px 0px !important;
    animation: openErrorModal 0.2s ease-out forwards;
    @keyframes openErrorModal {
      0% {
        transform: translate(0%, 0%);
      }
      100% {
        transform: translate(0%, -100%);
      }
    }
  }
  .outerModalClass {
    top: 100% !important;
    transform: translate(-50%, 0%) !important;
  }
`;

export default function CheckoutErrorModal({
  isErrorModalOpen,
  title,
  errorCode,
  message,
  handleClose,
  closeButtonText = 'Exit',
  isRetryAllowed = false,
  hideCloseButton = false,
  onRetryClick,
  retryButtonText,
  isRetryPrimary,
  isClosePrimary,
}: ErrorModalType) {
  const errorModalDispatch = useErrorModalContextDispatch();
  const [open, setOpen] = useState(false);
  const pathRef = useRef();
  const checkoutTracker = useCheckoutTracker();

  useEffect(() => {
    if (title) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [title]);

  const handleCloseModal = () => {
    setOpen(false);
    errorModalDispatch({
      type: 'MODAL/CLOSE',
    });
    if (onRetryClick) {
      onRetryClick();
    }
  };

  const handleCancelClick = () => {
    errorModalDispatch({
      type: 'MODAL/CLOSE',
    });
    setOpen(false);
    handleClose();
  };

  useEffect(() => {
    const handleBackClick = () => {
      if (open) {
        if (pathRef.current) {
          route(pathRef.current);
        }
        if (isRetryAllowed) {
          handleCloseModal();
        } else {
          handleCancelClick();
        }
      }
    };

    if (open) {
      const disableBackButton = () => {
        route(pathRef.current);
        window.addEventListener('popstate', handleBackClick);
      };

      disableBackButton();
    }

    return () => {
      window.removeEventListener('popstate', handleBackClick);
    };
  });

  useEffect(() => {
    if (isErrorModalOpen) {
      checkoutTracker.trackError('ec_pv_payment_error', undefined, {
        fail_reason: (title || '') + ' ' + (message || ''),
        error_code: errorCode,
      });
    }
  }, [isErrorModalOpen]);

  return (
    <ErrorModalContainer bothButtonsEnaled={isRetryAllowed && !hideCloseButton}>
      <Match>
        {({ path }) => {
          pathRef.current = path;
        }}
      </Match>
      <Modal
        open={open}
        className='errorModalBox'
        outerModalClass='outerModalClass'
        withCrossIcon={false}
        disableBackdropClick={true}>
        <div className='title'>{title}</div>
        <div className='message'>{message}</div>

        <div className='buttonsContainer'>
          {isRetryAllowed && (
            <CustomButton
              name={retryButtonText ? retryButtonText : 'Try Again'}
              className='retryButton'
              onClick={() => handleCloseModal()}
              containerClass='buttonContainer'
            />
          )}

          {!hideCloseButton && (
            <CustomButton
              name={closeButtonText}
              className='exitButton'
              onClick={handleCancelClick}
              track={(e) => {
                checkoutTracker.trackClick('ec_click_exit_error', undefined, {
                  button_label: e.target.name,
                });
              }}
              containerClass='buttonContainer'
            />
          )}
        </div>
      </Modal>
    </ErrorModalContainer>
  );
}



// WEBPACK FOOTER //
// ./components/checkoutWidget/CheckoutErrorModal.js